import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_VERSION, IOS_APP_STORE_URL, ANDROID_APK_URL, theme } from '../config';

const GetAppButton = ({ style, isMobile }) => {
    const navigate = useNavigate();

    const handleDownload = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.open(IOS_APP_STORE_URL, '_blank');
        } else if (/android/i.test(userAgent)) {
            const link = document.createElement('a');
            link.href = ANDROID_APK_URL;
            link.download = `myGUNI-${APP_VERSION}.apk`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            // Desktop or unknown -> go to Home page
            navigate('/');
        }
    };

    return (
        <button
            onClick={handleDownload}
            style={{
                background: theme.colors.primary,
                color: '#000',
                border: 'none',
                padding: isMobile ? `6px 10px` : `${theme.spacing.xs} ${theme.spacing.sm}`,
                borderRadius: theme.borderRadius.lg,
                fontWeight: theme.typography.fontWeight.bold,
                cursor: 'pointer',
                transition: 'transform 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing.xs,
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                ...style // Allow overriding styles
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
        >
            {isMobile ? 'App' : 'Get App'}
            <svg width={isMobile ? "16" : "20"} height={isMobile ? "16" : "20"} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
        </button>
    );
};

export default GetAppButton;
